import common from './modules/common' // 公共|组件|首页
import apiList from './modules/apiList' // api列表
import applied from './modules/applied' // 应用管理
import documentCenter from './modules/documentCenter' // 文档
import credentials from './modules/credentials' // 资质管理
import ChildAct from './modules/childAct' // 帮助中心
import InterDiary from './modules/InterDiary' // 接口日志
import pageHome from './modules/pageHome' // 接口日志
import login from './modules/login' // 登录
import developer from './modules/developer' // fuwu
import deveManager from './modules/deveManager' // 应用管理

// function keywordReinsertion (obj) {
//   let _obj = {}
//   for (let key of Object.keys(obj)) {
//     for (let item in obj[key]) {
//       _obj[key + '_' + item] = obj[key][item]
//     }
//   }
//   return _obj
// }

export default {
  ...apiList,
  ...common,
  ...applied,
  ...pageHome,
  ...ChildAct,
  ...credentials,
  ...documentCenter,
  ...InterDiary,
  ...login,
  ...developer,
  ...deveManager
}
// console.log('data', JSON.stringify(Object.keys(InterDiary).map(item => InterDiary[item].cn)).replace(/(",")/g, '\n'))
